// Position slots and canonical coordinates (for degradation distance calc)
export const SLOTS = [
  "GK", "LB", "LCB", "CB", "RCB", "RB", "LWB", "RWB",
  "DM", "LCM", "CM", "RCM", "AM", "LW", "RW", "ST", "LST", "RST",
];

// Canonical position on a vertical pitch (x 0-100 left->right, y 0 top(attack)->100 bottom(own goal))
export const SLOT_POS = {
  GK: { x: 50, y: 95 },
  LB: { x: 15, y: 72 }, LCB: { x: 38, y: 76 }, CB: { x: 50, y: 78 }, RCB: { x: 62, y: 76 }, RB: { x: 85, y: 72 },
  LWB: { x: 10, y: 60 }, RWB: { x: 90, y: 60 },
  DM: { x: 50, y: 60 }, LCM: { x: 35, y: 52 }, CM: { x: 50, y: 54 }, RCM: { x: 65, y: 52 }, AM: { x: 50, y: 40 },
  LW: { x: 15, y: 28 }, RW: { x: 85, y: 28 }, ST: { x: 50, y: 15 }, LST: { x: 40, y: 18 }, RST: { x: 60, y: 18 },
};

// Formations: ordered slot codes with display coordinates
export const FORMATIONS = {
  "4-4-2": ["GK", "LB", "LCB", "RCB", "RB", "LW", "LCM", "RCM", "RW", "LST", "RST"],
  "4-3-3": ["GK", "LB", "LCB", "RCB", "RB", "LCM", "CM", "RCM", "LW", "ST", "RW"],
  "3-5-2": ["GK", "LCB", "CB", "RCB", "LWB", "LCM", "CM", "RCM", "RWB", "LST", "RST"],
  "4-2-3-1": ["GK", "LB", "LCB", "RCB", "RB", "LCM", "RCM", "LW", "AM", "RW", "ST"],
  "5-3-2": ["GK", "LWB", "LCB", "CB", "RCB", "RWB", "LCM", "CM", "RCM", "LST", "RST"],
};

export const FORMATION_NAMES = Object.keys(FORMATIONS);

// Display coordinates per formation (percentage based)
export const FORMATION_COORDS = {
  "4-4-2": {
    GK: { x: 50, y: 92 }, LB: { x: 15, y: 72 }, LCB: { x: 38, y: 75 }, RCB: { x: 62, y: 75 }, RB: { x: 85, y: 72 },
    LW: { x: 15, y: 46 }, LCM: { x: 38, y: 49 }, RCM: { x: 62, y: 49 }, RW: { x: 85, y: 46 }, LST: { x: 38, y: 18 }, RST: { x: 62, y: 18 },
  },
  "4-3-3": {
    GK: { x: 50, y: 92 }, LB: { x: 15, y: 72 }, LCB: { x: 38, y: 75 }, RCB: { x: 62, y: 75 }, RB: { x: 85, y: 72 },
    LCM: { x: 30, y: 53 }, CM: { x: 50, y: 56 }, RCM: { x: 70, y: 53 }, LW: { x: 18, y: 22 }, ST: { x: 50, y: 15 }, RW: { x: 82, y: 22 },
  },
  "3-5-2": {
    GK: { x: 50, y: 92 }, LCB: { x: 30, y: 76 }, CB: { x: 50, y: 78 }, RCB: { x: 70, y: 76 },
    LWB: { x: 12, y: 54 }, LCM: { x: 35, y: 52 }, CM: { x: 50, y: 55 }, RCM: { x: 65, y: 52 }, RWB: { x: 88, y: 54 },
    LST: { x: 38, y: 18 }, RST: { x: 62, y: 18 },
  },
  "4-2-3-1": {
    GK: { x: 50, y: 92 }, LB: { x: 15, y: 72 }, LCB: { x: 38, y: 75 }, RCB: { x: 62, y: 75 }, RB: { x: 85, y: 72 },
    LCM: { x: 38, y: 58 }, RCM: { x: 62, y: 58 }, LW: { x: 16, y: 34 }, AM: { x: 50, y: 38 }, RW: { x: 84, y: 34 }, ST: { x: 50, y: 14 },
  },
  "5-3-2": {
    GK: { x: 50, y: 92 }, LWB: { x: 10, y: 66 }, LCB: { x: 32, y: 76 }, CB: { x: 50, y: 78 }, RCB: { x: 68, y: 76 }, RWB: { x: 90, y: 66 },
    LCM: { x: 32, y: 50 }, CM: { x: 50, y: 52 }, RCM: { x: 68, y: 50 }, LST: { x: 38, y: 20 }, RST: { x: 62, y: 20 },
  },
};

export const LEAGUES = [
  { id: "elite", name: "Elite League", country: "England", locale: "en-GB", langHint: "en" },
  { id: "oberklasse", name: "Oberklasse", country: "Germany", locale: "de-DE", langHint: "de" },
  { id: "primera", name: "Liga Primera", country: "Spain", locale: "es-ES", langHint: "es" },
];

export const FIXTURE_STATES = ["OPEN", "LOCKED", "REVEALED", "IN_PLAY", "SETTLED"];

// Entity color tokens
export const ENTITY = {
  you: { key: "you", color: "#b6ff2e" },
  coach: { key: "coach", color: "#ffb547" },
  ai: { key: "ai", color: "#3fd7e5" },
};
